import { helper } from '@ember/component/helper';

/**
 * Verifica se un valore è presente in un array
 */
var inArray = helper(([searchValue, array]) => Array.isArray(array) && array.includes(searchValue));

export { inArray as default };
//# sourceMappingURL=in-array.js.map
